import { PushBuffer, DEFAULT_BUFFER_SIZE } from './PushBuffer';
import { Pipeline } from './Pipeline';
/**
 * Pipeline that is also a PushBuffer.
 * i.e. can call .push to push data into pipeline and .pipe to transform it.
 */
export class PushPipeline extends Pipeline {
    source;
    constructor(bufferSize = DEFAULT_BUFFER_SIZE) {
        const inputBuffer = new PushBuffer(bufferSize);
        super(inputBuffer);
        this.source = inputBuffer;
    }
    pipe(fn) {
        // this method override just fixes the output type to be PushPipeline rather than Pipeline
        super.pipe(fn);
        return this;
    }
    filter(fn) {
        // this method override just fixes the output type to be PushPipeline rather than Pipeline
        return super.filter(fn);
    }
    // wrapped PushBuffer methods below here
    async push(item) {
        return this.source.push(item);
    }
    async handleError(err) {
        try {
            await this.onError.trigger(err);
        }
        catch (error) {
            if (this.isCleaningUp) {
                throw error;
            }
            await this.push(error);
        }
    }
    end(err) {
        this.source.end(err);
    }
    endWrite(err) {
        this.source.endWrite(err);
    }
    isDone() {
        return this.source.isDone();
    }
    get length() {
        return this.source.length || 0;
    }
    clear() {
        this.source.clear();
    }
}
//# sourceMappingURL=PushPipeline.js.map